import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import { GetBannersResponse, GetPersonalizedCareCardsResponse } from './banners.types';

/**
 * RTK Query API slice for retrieving promotional and notification banners.
 */
export const bannersApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getBanners: build.query<GetBannersResponse, void>({
      providesTags: ['Banners'],
      query: () => ({ url: '/banners' })
    }),
    getPersonalizedCareCards: build.query<GetPersonalizedCareCardsResponse, void>({
      providesTags: ['PersonalizedCare'],
      query: () => ({ url: '/personalized-care-banners' })
    })
  }),
  reducerPath: 'bannersApi',
  tagTypes: ['Banners', 'PersonalizedCare']
});

export const { useGetBannersQuery, useGetPersonalizedCareCardsQuery, useLazyGetBannersQuery } =
  bannersApi;
